/**
 * Minimal splash for PWA — unused when App skips splash on web, but kept safe
 * if something mounts it (no covering overlay, no deprecated props).
 */
import React, { useEffect, useRef } from 'react';
import { Image, StyleSheet, View } from 'react-native';
import { setSplashCovering, setSplashPageReady } from '@src/lib/splashGate';

const APP_ICON = require('../../../src/assets/dummy.png');

type Props = {
  can_dismiss: boolean;
  on_exit_complete: () => void;
};

export function AppSplashScreen({ can_dismiss, on_exit_complete }: Props) {
  const exited = useRef(false);

  const exit = () => {
    if (exited.current) {
      return;
    }
    exited.current = true;
    setSplashCovering(false);
    on_exit_complete();
  };

  useEffect(() => {
    // Never cover the UI on PWA — MainScreen must stay visible.
    setSplashCovering(false);
    setSplashPageReady(true);
    const timer = setTimeout(exit, 0);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (can_dismiss) {
      exit();
    }
  }, [can_dismiss]);

  // Transparent no-op host so we never paint a white overlay over Auth/Main.
  return (
    <View style={styles.root}>
      <Image source={APP_ICON} style={styles.icon} resizeMode="contain" />
    </View>
  );
}

export default AppSplashScreen;

const styles = StyleSheet.create({
  root: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'transparent',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: -1,
    pointerEvents: 'none',
  },
  icon: {
    width: 0,
    height: 0,
    opacity: 0,
  },
});
